'use client';
import React from 'react';

import { AccordionProps } from './accordion';

const AccordionContext = React.createContext<AccordionProps | undefined>(
  undefined
);

AccordionContext.displayName = 'AccordionContext';

export default AccordionContext;
